import type { TwicpicsParams } from '~~/types/twicpics/twicpics';

export const getUrlWithResizeQuery = (src: string, params: TwicpicsParams) => {

  return `${src}?twic=v1/${params.mode}=${params.width}x${params.height}`;

};
